import { GenerationMethod } from '@heidi/schema/ml-scribe';
import { skipToken, useQuery } from '@tanstack/react-query';
import { GET_TEMPLATE_BY_ID } from '../../contracts';
import { getInternalTemplateById, getTemplateById } from '../api/templates';

/**
 * `skipCheckOwnTemplate` arrives composed. Pre-move this hook combined two app
 * reads — `useIsReviewingOtherUser()` (a WORKSPACE fact, from the user record)
 * and `useIsOwnTemplate()` (which itself runs a templates query). Pulling the
 * workspace read in would forge a `templates -> workspace` edge for one
 * boolean, so the delegate composes both at the same render-time position and
 * passes the decision (cohort-C).
 */
export function useQueryTemplateById(
  templateId: string | null | undefined,
  generationMethod: GenerationMethod | null | undefined,
  skipCheckOwnTemplate = true
) {
  return useQuery({
    queryKey: [GET_TEMPLATE_BY_ID, { templateId }, generationMethod],
    queryFn:
      templateId && skipCheckOwnTemplate
        ? async () => {
            if (generationMethod === GenerationMethod.INTERNAL_TEMPLATE) {
              const { data } = await getInternalTemplateById(templateId);
              return data;
            }
            const { data } = await getTemplateById(templateId);
            return data;
          }
        : skipToken,
  });
}
